<template>
    <div class="card h-100">
      <div class="card-body text-center d-flex flex-column justify-content-between align-items-center">
        <div class="container row" style="background: #283335;margin-top: 0 !important;">
          <div v-if="data" class="col wd-50" 
            style="display: flex; justify-content: space-around;padding-left:0rem !important">
            <UserPerformanceMeter :selected-date="period" :data="data" /> 
          </div>
          <div class="col wd-50 div-separator">
            <UserPerformanceDetails 
              :performance= "performanceData" :data="data" />
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import UserPerformanceMeter from "./UserPerformanceMeter.vue";
  import UserPerformanceDetails from "./UserPerformanceDetails.vue";

  export default {
    name: 'UserPerformance',
    props: {
        id: {
         type: String,
         default: "progress-doughnut-chart",
        },
        title: {
        type: String,
        default: "Doughnut Chart",
        },
        period: {
        type: String,
        default: "",
        },
        data: {
         type: Object,
         required: true,
        },
        performanceData: {
          type: Object,
          required: true,
        }
    },
    components: {
        UserPerformanceMeter,
        UserPerformanceDetails,
    },
    data() {
        return {
            chartData: this.data
        }
    },
    mounted() {
    },
    methods: {
    },
    watch: {
      performanceData(){
      },
      data(){
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .div-separator {
    border-left: 0.1rem solid #4e5155;
    border-width: thin;
    padding-left: 1.5rem;
  }
  .performance-details {
    padding:0.5rem;
    text-align: left;
    color: #bce1da;
  }
  .performance-details span {
    padding-left: 0.2rem;
  }
  .stats {
    font-size: 1rem;
  }
  .stats-unit {
    font-size: 0.85rem;
    font-weight: 100;
  }
  .last-sync-details {
    text-align: right;
    font-size: 0.9rem;
    color: #B0B0B0;
  }
  .performance-label {
    margin-bottom: 0;
  }
  </style>
  